// extracted by mini-css-extract-plugin
export default {"image":"image--5352404f","add":"add--b25a5a51","thumb":"thumb--78f4417c","file":"file--02b6e395","pdf":"pdf--6c0f8b35","close":"close--b5c24fbe"};